import { frontendURL } from 'dashboard/helper/URLHelper.js';

import CampaignsPageRouteView from './pages/CampaignsPageRouteView.vue';
import CampaignsV2Page from './pages/v2/CampaignsV2Page.vue';
import CampaignWizard from './pages/v2/CampaignWizard.vue';
import CampaignAnalyticsPage from './pages/v2/CampaignAnalyticsPage.vue';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const meta = {
  featureFlag: FEATURE_FLAGS.CAMPAIGNS,
  permissions: ['administrator'],
};

const campaignsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/campaigns'),
      component: CampaignsPageRouteView,
      children: [
        {
          path: '',
          name: 'campaigns_index',
          meta,
          component: CampaignsV2Page,
        },
        {
          path: 'new',
          name: 'campaigns_new',
          meta,
          component: CampaignWizard,
        },
        {
          path: ':campaignId/edit',
          name: 'campaigns_edit',
          meta,
          component: CampaignWizard,
        },
        {
          path: ':campaignId',
          name: 'campaigns_analytics',
          meta,
          component: CampaignAnalyticsPage,
        },
      ],
    },
  ],
};

export default campaignsRoutes;
